import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  mutation CreateThread($courseId: String!, $input: CreateThreadInput!) {
    createThread(courseId: $courseId, input: $input)
      @rest(
        type: "Thread"
        path: "courses/{args.courseId}/threads"
        method: "POST"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
